import React from "react";

export const ChevronLeftIcon = ({ className }: { className?: string }) => (
  <svg
    width="9"
    height="14"
    viewBox="0 0 9 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M8 1L2 7L8 13" stroke="currentColor" strokeWidth="2" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/containers/HomePage/ChevronLeftIcon.tsx